import { render, staticRenderFns } from "./listProviders.vue?vue&type=template&id=3273e186"
import script from "./listProviders.vue?vue&type=script&lang=js"
export * from "./listProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports